





















































import Vue from 'vue'
import { AuthCredentials } from '@/interfaces/app/Auth'

export default Vue.extend({
  name: 'login',
  data() {
    return {
      valid: false,
      loading: false,
      username: '',
      password: '',
      rules: {
        username: [
          (v: string): boolean | string =>
            !!v || 'Uživatelské jméno je povinné',
        ],
        password: [(v: string): boolean | string => !!v || 'Heslo je povinné'],
      },
    }
  },
  computed: {
    loginForm(): any {
      return this.$refs.loginForm as any
    },
  },
  methods: {
    submit(): void {
      if (this.loginForm.validate()) {
        this.loading = true
        this.$store
          .dispatch('user/login', {
            username: this.username,
            password: this.password,
          })
          .then(() => {
            this.$router.push({ name: 'valuation' })
          })
          .finally(() => (this.loading = false))
      }
    },
  },
})
